import * as React from 'react';
import styled from 'styled-components';

import useClientTranslations from '../../hooks/useClientTranslations';
import { CallToAction } from '../shared/CallToAction';

interface CreateClaimNoticeProps {
	redirectUrl: string;
}

// Translation keys in this portal are the copy itself, so whatever is written here is what renders
// when no entry exists in Locize. The only client this notice is configured for is French-speaking,
// so the copy is held in French to keep it correct even before the translations are published.
// A Locize entry for these keys still overrides them, and any future client enabling
// createClaimRedirectUrl must add their own translations rather than inherit this fallback.
const NOTICE_TITLE = 'La création de sinistres n’est plus disponible depuis ce portail';

const NOTICE_BODY =
	'Créez désormais vos estimations sur le nouveau portail Tractable.\n' +
	'Votre mot de passe reste inchangé.\n' +
	'Pensez à enregistrer cette adresse dans vos favoris.\n' +
	'Ce portail ne sera plus maintenu à partir du 15/10.';

const NOTICE_LINK = 'Accéder au nouveau portail';

const Body = styled.div`
	white-space: pre-line;
	max-width: 46rem;
`;

const CreateClaimNotice: React.FC<CreateClaimNoticeProps> = ({ redirectUrl }) => {
	const { t } = useClientTranslations();

	return (
		<Body data-test-id="createClaimNotice">
			<CallToAction title={t(NOTICE_TITLE)} text={t(NOTICE_BODY)}>
				<a
					data-test-id="createClaimRedirectLink"
					className="bp3-button bp3-intent-primary"
					style={{ backgroundColor: '#3B25C4' }}
					href={redirectUrl}
					target="_blank"
					rel="noopener noreferrer"
				>
					{t(NOTICE_LINK)}
				</a>
			</CallToAction>
		</Body>
	);
};

export { CreateClaimNotice, NOTICE_LINK };
